import { InjectionToken } from '@angular/core';
import type { NgForm } from '@angular/forms';
import type { FormRowStatus, FormType } from './domain/form.domain';

export interface FormRowRef {
  id: number;
}

export interface FormHost {
  formType(): FormType;
  formElement(): NgForm;
  addRow(row: FormRowRef): FormRowRef;
  removeRow(row: FormRowRef): void;
  setRowStatus(rowStatus: FormRowStatus): void;
}

export const FORM_HOST = new InjectionToken<FormHost>('FormHost');
